export const HarriMainRoutes = {
    "": {
        "name": "appLayout",
        "type": "frontend",
        "abstract": true,
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "component": "harriLayoutContainer",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import('./harri-main.module.js');
                }
            }
        ],
    }
};